var _path, _path2, _polygon, _path3, _path4, _path5, _circle, _polygon2, _rect, _path6, _path7, _path8, _path9, _path10, _polygon3, _circle2, _path11, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _polygon4, _path12, _path13, _path14, _circle9, _path15, _path16, _path17, _path18, _circle10, _path19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookhero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 766,
    height: 663.78,
    viewBox: "0 0 766 663.78",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M292.871,732.64839c-6.9791,23.31316,3.85236,47.1484,3.85236,47.1484s22.14678-13.96279,29.12586-37.276-3.85236-47.14841-3.85236-47.14841S299.85012,709.33525,292.871,732.64839Z",
    transform: "translate(-217 -118.11)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.4675,733.27893c5.87388,23.61585-6.0677,46.91481-6.0677,46.91481s-21.465-14.98989-27.33882-38.60574,6.06764-46.91479,6.06764-46.91479S297.59362,709.66308,303.4675,733.27893Z",
    transform: "translate(-217 -118.11)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "435.535 638.619 439.977 627.192 398.017 604.619 391.461 621.484 435.535 638.619",
    fill: "#ffb8b8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M676.33666,726.91969a15.37868,15.37868,0,0,0-19.91544,8.7659l-2.9969,7.703-4.62021,11.89009-1.12945,2.91539,14.80606,5.75954,14.32146-36.84918Z",
    transform: "translate(-217 -118.11)",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M648.80588,734.73787l-1.93215,5.12355-4.82182,12.78824-.11567.31983c-12.28491,1.57847-25.75239-1.516-38.20882-6.32324a155.31182,155.31182,0,0,1-14.62441-6.52576c-7.04426-3.5593-13.35151-7.31588-18.38323-10.52878-7.57588-4.86233-12.26034-8.51324-12.26034-8.51324s-1.23757,1.11835-3.477,3.03611c-3.00151,2.56814-7.79768,6.57847-13.87288,11.29915q-3.47624,2.7201-7.46478,5.69034c-19.60112,14.53884-44.75556-24.2561-44.75556-24.2561s7.07456-4.504,8.92274-5.37858c5.95119-2.81556,19.93229-9.4593,31.99433-15.36345,6.21425-3.04642,11.91181-5.90255,15.73713-7.93248,13.54579-7.212,30.38421,6.43472,30.38421,6.43472Z",
    transform: "translate(-217 -118.11)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M648.80588,734.73787l-1.93215,5.12355-4.82182,12.78824-.11567.31983c-12.28491,1.57847-25.75239-1.516-38.20882-6.32324a155.31182,155.31182,0,0,1-14.62441-6.52576c-7.04426-3.5593-13.35151-7.31588-18.38323-10.52878-7.57588-4.86233-12.26034-8.51324-12.26034-8.51324s-1.23757,1.11835-3.477,3.03611c-3.00151,2.56814-7.79768,6.57847-13.87288,11.29915q-3.47624,2.7201-7.46478,5.69034c-19.60112,14.53884-44.75556-24.2561-44.75556-24.2561s7.07456-4.504,8.92274-5.37858c5.95119-2.81556,19.93229-9.4593,31.99433-15.36345,6.21425-3.04642,11.91181-5.90255,15.73713-7.93248,13.54579-7.212,30.38421,6.43472,30.38421,6.43472Z",
    transform: "translate(-217 -118.11)",
    opacity: 0.14
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.57878,
    cy: 172.3117,
    r: 172.3117,
    fill: "#0eafe9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.34937,175.331A172.32514,172.32514,0,0,0,560.4716,357.70067,172.32654,172.32654,0,1,1,273.34937,175.331Z",
    transform: "translate(-217 -118.11)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.052 172.311 184.526 172.311 193.047 660.843 175.058 660.843 184.052 172.311",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 382.52342,
    y: 507.1554,
    width: 8.5209,
    height: 32.19013,
    transform: "translate(-473.4058 503.62826) rotate(-62.23413)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M982,780.89786H218a1,1,0,0,1,0-2H982a1,1,0,0,1,0,2Z",
    transform: "translate(-217 -118.11)",
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M452.746,627.18653h-58a4.50508,4.50508,0,0,1-4.5-4.5v-25a33.5,33.5,0,0,1,67,0v25A4.50508,4.50508,0,0,1,452.746,627.18653Z",
    transform: "translate(-217 -118.11)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M507.9036,658.58833a9.377,9.377,0,0,0-7.1855,12.45427l-15.77152,14.50579,6.47754,11.7343,21.98473-20.7978a9.42779,9.42779,0,0,0-5.50525-17.89656Z",
    transform: "translate(-217 -118.11)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M460.44794,724.54q-1.06862,0-2.14038-.09229A25.19929,25.19929,0,0,1,438.01,710.89248l-25.26734-48.63281a13.95418,13.95418,0,0,1,24.12989-13.96484l23.31079,52.30371,31.71924-25.772,18.36572,7.14941-31.01611,34.2417A25.48478,25.48478,0,0,1,460.44794,724.54Z",
    transform: "translate(-217 -118.11)",
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M553.91347,649.39517l-28.10169-28.10174a5.24193,5.24193,0,0,0-7.41315,0l-25.2799,25.27991a5.24192,5.24192,0,0,0,0,7.41314l26.25647,26.25647a5.24188,5.24188,0,0,0,7.13348.26l27.12512-23.43463a5.24189,5.24189,0,0,0,.53968-7.39349Q554.04859,649.53036,553.91347,649.39517Z",
    transform: "translate(-217 -118.11)",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.935 536.213 304.009 507.288 280.138 531.159 307.941 558.961 332.935 536.213",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.05974,
    cy: 532.88576,
    r: 11.74605,
    fill: "#0eafe9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.28786,661.00711a11.74609,11.74609,0,0,0-11.96552-19.632,11.74565,11.74565,0,1,1,10.65973,20.69257A11.8299,11.8299,0,0,0,528.28786,661.00711Z",
    transform: "translate(-217 -118.11)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M517.2848,648.66159c-1.40075,1.31617-1.47485,6.05414.66394,8.33039s5.68061,1.22888,7.08136-.08728.13013-2.40278-2.00872-4.67908S518.68562,647.34543,517.2848,648.66159Z",
    transform: "translate(-217 -118.11)",
    fill: "#f2f2f2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.20912,
    cy: 533.07722,
    r: 3.4803,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.95329,
    cy: 526.41933,
    r: 3.4803,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.20912,
    cy: 533.07722,
    r: 0.87007,
    fill: "#f2f2f2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 312.58363,
    cy: 530.93452,
    r: 0.43504,
    fill: "#f2f2f2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 306.32777,
    cy: 524.27663,
    r: 0.43504,
    fill: "#f2f2f2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 305.95329,
    cy: 526.41933,
    r: 0.87007,
    fill: "#f2f2f2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "431.99 654.69 437.297 643.639 397.196 617.909 389.363 634.22 431.99 654.69",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M675.01215,744.90787a15.37868,15.37868,0,0,0-20.53,7.21l-3.57984,7.45-5.52,11.5-1.35009,2.82,14.31982,6.88,17.11011-35.64Z",
    transform: "translate(-217 -118.11)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M646.9621,750.58786l-2.32007,4.96-5.79,12.38-.13989.31c-12.36988.63-25.55982-3.49-37.61011-9.24a155.31151,155.31151,0,0,1-14.07983-7.63c-6.75-4.09-12.75-8.32-17.52-11.91-7.17994-5.43-11.57007-9.43-11.57007-9.43s-1.31983,1.02-3.69995,2.76c-3.18995,2.33-8.28,5.96-14.7,10.2q-3.67494,2.445-7.87989,5.1c-20.66015,12.99-50.04,28.81-75.03027,32.15-43.88989,5.87-33.55982-52.7-33.55982-52.7l34.92994-18.14,14.83007,3.01,16.51,3.34,5.84986,1.19s1.1101-.42,3.02-1.15c6.1499-2.35,20.60009-7.9,33.08008-12.86005,6.42993-2.56,12.33007-4.97,16.3-6.7,14.05982-6.15,29.8,8.75,29.8,8.75Z",
    transform: "translate(-217 -118.11)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M359.14474,781.63626a9.377,9.377,0,0,0,6.532-12.80913l15.00042-15.30183-7.07558-11.3837-20.88,21.90668a9.42779,9.42779,0,0,0,6.4232,17.588Z",
    transform: "translate(-217 -118.11)",
    fill: "#ffb8b8"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 214.9579,
    cy: 486.80653,
    r: 23.38625,
    fill: "#ffb8b8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M401.53314,669.83389,421.905,727.58975l-.12232.20215c-2.83349,4.68408-3.75952,8.4624-2.67773,10.92627a4.76117,4.76117,0,0,0,3.01855,2.604l48.20874-33.69678-1.688-13.50537.094-.15088c4.65967-7.45556,6.16846-14.20751,4.48511-20.06738-2.18433-7.604-9.12549-11.05615-9.19532-11.09033l-.168-.13232L439.81512,633.414,407.673,639.12442Z",
    transform: "translate(-217 -118.11)",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M370.55316,771.20938,356.9057,754.4125l32.89941-54.30957,15.33863-47.41259.47583.1538-.47583-.1538a19.04653,19.04653,0,1,1,33.96362,16.43652l-28.15967,42.189Z",
    transform: "translate(-217 -118.11)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M465.17131,600.18653H429.70573l-.36377-5.0918-1.81836,5.0918h-5.46093l-.72071-10.0918-3.604,10.0918H407.17131v-.5a26.52975,26.52975,0,0,1,26.49975-26.5h5.00025a26.53,26.53,0,0,1,26.5,26.5Z",
    transform: "translate(-217 -118.11)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M429.41548,631.85328a4.5972,4.5972,0,0,1-.79639-.07031l-25.96948-4.582V584.281H431.237l-.70777.8252c-9.84716,11.48437-2.42846,30.10645,2.87012,40.18457a4.43339,4.43339,0,0,1-.35229,4.707A4.48192,4.48192,0,0,1,429.41548,631.85328Z",
    transform: "translate(-217 -118.11)",
    fill: "#2f2e41"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 588.13918,
    cy: 324.68944,
    r: 113.99999,
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M775.99213,398.48812v96.99122a2.49731,2.49731,0,0,0,3.74028,2.30172l76.88333-48.49562a2.74779,2.74779,0,0,0,0-4.57144l-76.88333-48.49563a2.47393,2.47393,0,0,0-3.74028,2.26975Z",
    transform: "translate(-217 -118.11)",
    fill: "#f2f2f2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookhero);
export default __webpack_public_path__ + "static/media/Bookhero.40bd671db78a03b38c82913124385f51.svg";
export { ForwardRef as ReactComponent };